/**
 * Doorbijters Theme - Critical JavaScript Entry
 * =============================================
 * This file contains JavaScript that is critical for above-the-fold content.
 * This JS is loaded in the <head> to prevent FOUC (Flash of Unstyled Content).
 *
 * Keep this file as small as possible for optimal performance!
 * Only include code that is absolutely necessary for initial page render.
 */

// Import critical modules
import './critical/font-loader.js';
import './critical/above-fold.js';

// Mark when critical JS is loaded (useful for performance monitoring)
window.__CRITICAL_JS_LOADED__ = true;
